<vi-page [sidenavs]="true" [footer]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <ng-container body>
    <ng-container
      *ngIf="bookingStore.buySubscriptionError$ | async as error; else subscriptionSuccess"
    >
      <div
        class="error-container flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
      >
        <img class="error-img" src="assets/img/installer-error.svg" data-at-failed-subscription />
        <h1>{{ '+BOOKING.CHECKOUT.ERROR.TITLE' | translate }}</h1>
        <p *ngIf="error?.extendedPayload || error?.errorType">
          {{
            '+BOOKING.CHECKOUT.ERROR.' + (error.extendedPayload?.errorType || error.errorType)
              | translate
          }}
        </p>
        <div
          class="flex flex-row lt-md:flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
        >
          <button
            *ngIf="!invoiceNumber"
            class="back-button"
            gtm="onGoToPage"
            gtmAction="Booking 1st step"
            gtmCategory="booking"
            mat-stroked-button
            data-at-go-back-to-booking-button
            [routerLink]="['/booking']"
          >
            <mat-icon>arrow_back</mat-icon>
            <span>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.ERROR_BTN' | translate }}</span>
          </button>
          <button
            *ngIf="invoiceNumber"
            class="back-button"
            gtm="onGoToPage"
            gtmAction="Booking overview"
            gtmCategory="bookingSummary"
            mat-raised-button
            color="primary"
            [routerLink]="['/booking-overview']"
          >
            <mat-icon>arrow_back</mat-icon>
            <span>{{
              '+BOOKING.SUBSCRIPTION_SUMMARY.GO_TO_BOOKING_OVERVIEW_BTN' | translate
            }}</span>
          </button>

          <ng-container *ngIf="bookingStore.showPlantOverviewLink$ | async">
            <app-plant-overview-link
              data-at-plant-overview-button
              *appForCountries="plantOverviewCountries"
              [overviewUrl]="overviewUrl"
            ></app-plant-overview-link>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-template #subscriptionSuccess>
      <ng-container *ngIf="bookingStore.selectedDevices$ | async as selectedDevices" main>
        <div *ngIf="bookingStore.selectedPlan$ | async as plan" class="summary-wrapper">
          <div class="summary-image-wrapper">
            <img
              icon
              class="summary-image"
              data-at-commissioning-img
              src="/assets/img/booking-success-technician.svg"
            />
          </div>
          <p class="summary-header">
            {{ '+BOOKING.SUBSCRIPTION_SUMMARY.ACKNOWLEDGEMENT' | translate }}
          </p>
          <p data-at-subscribed-package="Pro" *ngIf="plan === BookingPlans.Pro">
            {{ '+BOOKING.SUBSCRIPTION_SUMMARY.DESCRIPTION_PRO' | translate }}
          </p>
          <p data-at-subscribed-package="Plus" *ngIf="plan === BookingPlans.Plus">
            {{ '+BOOKING.SUBSCRIPTION_SUMMARY.DESCRIPTION_PLUS' | translate }}
          </p>
          <div class="subscription-buttons">
            <button
              *ngIf="selectedDevices.length > 1"
              data-at-go-to-devices-button
              gtm="onGoToPage"
              gtmAction="Booking overview"
              gtmCategory="bookingSummary"
              mat-raised-button
              color="primary"
              class="subscription-buttons__btn booking-btn"
              [routerLink]="['/booking-overview']"
            >
              <span>{{ 'SHARED.SIDENAV.BOOKING_OVERVIEW' | translate }}</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            <button
              data-at-go-to-devices-button
              gtm="onGoToPage"
              gtmAction="Installation details"
              gtmCategory="bookingSummary"
              mat-raised-button
              color="primary"
              class="subscription-buttons__btn"
              [routerLink]="bookingService.getRouterLinkAfterPurchase(selectedDevices)"
            >
              <span *ngIf="selectedDevices.length === 1">
                {{ '+BOOKING.SUBSCRIPTION_SUMMARY.GO_TO_DEVICE' | translate }}
              </span>
              <span *ngIf="selectedDevices.length > 1">
                {{ '+BOOKING.SUBSCRIPTION_SUMMARY.INSTALLATIONS_REDIRECTION' | translate }}
              </span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
